import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthContext';

/**
 * Hook principal de auth. Devuelve user/isAuthenticated/isLoading/error/refetch.
 *
 * Cualquier component que necesite saber "¿quién está logueado?" usa este hook.
 * Story SW-311.
 */
export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}
